// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3QPRl","modal":"Modal_modal__37ks8","slide-down":"Modal_slide-down__24D2A"};